import { CommandParam } from "./CommandParam";
import { DataBoxRequest } from "./DataBoxRequest";
//import { IonToast } from "@ionic/vue";

import { CommandExecutionType } from "./CommandExecutionType";
import { ParameterDirection } from "./ParameterDirection";
import { DbParamType } from "./DbParamType";
import { SystemVariable } from "./SystemVariable";
import axios from "axios";

class DataBoxCall {
  constructor() {
    this.ctr = false;
    this.tmr = {};
  }

  /*async showToast(messaggio, colore) {
    const toast = await this.$ionic.toastController.create({
      message: messaggio,
      position: "top",
      duration: 3000,
      color: colore,
    });

    await toast.present();
  }*/

  //passo la funzione da 'ritardare'
  GoAhead(funzione) {
    if (this.ctr) {
      //salto - posticipo la richiesta
      if (this.tmr) {
        //annullo eventuali precedenti promesse
        setTimeout.cancel(this.tmr);
      }
      this.tmr = setTimeout(funzione, 500);
      return false;
    } else {
      this.ctr = true;
      return true;
    }
  }

  //libera le chiamate
  EndCall() {
    this.ctr = false;
  }

  Exec(prm, ProcName, showError, ErrorMessage, execType, scrollTop, cfg, ErrorFunction) {
    if (
      !execType ||
      (execType != CommandExecutionType.ExecuteQuery &&
        execType != CommandExecutionType.ExecuteNonQuery)
    ) {
      execType = CommandExecutionType.ExecuteQuery;
    }

    //di default non mostra errori
    if (!showError) {
      showError = false;
    }

    if (!ErrorMessage) {
      ErrorMessage = "E' occorso un errore";
    }

    //riporta in cima lo scroll
    if (scrollTop) {
      //$ionicScrollDelegate.scrollTop();
    }
    //var _httpTimeout = $q.defer();

    //controllo se in prm non c'è USR_codi e errmsg lo aggiungo
    var i;
    var bUsr_codi = false;
    var berrMsg = false;

    var prm1 = [];
    for (i = 0; i < prm.length; i++) {
      if (prm[i]["Name"] === "@Usr_codi") {
        bUsr_codi = true;
      } else if (prm[i]["Name"] === "@errMsg") {
        berrMsg = true;
      }

      //se ho finito di scorrere i parametri di input e non c'è Usr_codi lo aggiungo come ultimo parametro di input
      if (prm[i]["Direction"] === ParameterDirection.Output && !bUsr_codi) {
        prm1.push(
          new CommandParam(
            "@Usr_codi",
            "",
            DbParamType.SysVariable,
            0,
            ParameterDirection.Input,
            SystemVariable.USER_ID
          )
        );
        bUsr_codi = true;
      }

      prm1.push(prm[i]);
    }

    if (!bUsr_codi) {
      prm1.push(
        new CommandParam(
          "@Usr_codi",
          "",
          DbParamType.SysVariable,
          0,
          ParameterDirection.Input,
          SystemVariable.USER_ID
        )
      );
    }

    //aggiungo come ultimo parametro se non è stato letto fino ad ora
    if (!berrMsg) {
      prm1.push(
        new CommandParam(
          "@errMsg",
          "errMsg",
          DbParamType.AnsiStringFixedLength,
          7,
          ParameterDirection.Output,
          null
        )
      );
    }

    return axios({
      method: "post",
      url: cfg.$API_DBOX_URL,
      crossDomain: true,
      data: new DataBoxRequest(
        execType,
        ProcName,
        prm1,
        cfg.$JwtToken,
        cfg.$API_KEY
      ),
      //timeout: _httpTimeout.promise
    }).then(
      //success
      function (response) {
        if (typeof response.data === "object") {
          if (response.data.ErrorMessage && response.data.ErrorMessageID >= 0) {
            //errori generici di comunicazione
            if (showError) {
              ErrorMessage = ErrorMessage + "\n" + response.data.ErrorMessage;
              //this.showToast(ErrorMessage, "warning");
              if (ErrorFunction){
                ErrorFunction(ErrorMessage);
              }
            }
            console.warn(response.data.ErrorMessage);
            return Promise.reject(response.data);
          } else if (
            response.data.ErrorMessageID >= 0 &&
            response.data.OutputParams.Table[0]["errMsg"] != null
          ) {
            //erorre gestito di procedura
            //DA RIFARE!!!!
            //$rootScope.DecodeErrorMessagge(
            //  response.data.OutputParams.Table[0]["errMsg"]
            //);
            return Promise.reject(response.data);
          }
          //tutto ok ritornano dati e quanto altro
          return response.data;
        } else {
          if (showError) {
            //this.showToast(ErrorMessage, "warning");
            if (ErrorFunction){
              ErrorFunction(ErrorMessage);
            }
            console.warn(ErrorMessage);
          }

          // invalid response
          return Promise.reject(response.data);
        }
      },
      //error
      function (response) {
        if (showError) {
          //this.showToast(ErrorMessage, "warning");
          if (ErrorFunction){
            ErrorFunction(ErrorMessage);
          }
          console.warn(ErrorMessage);
        }

        return Promise.reject(response.data);
      }
    ).catch(e =>{
      console.warn(e);
      if (ErrorFunction){
        ErrorFunction(e);
      }
    })
  }
}

export let dataBoxCall = new DataBoxCall();